// extracted by mini-css-extract-plugin
export default {"mdx-wrapper":"knXO8ACkqv1iSI7RtHGJ","mdxWrapper":"knXO8ACkqv1iSI7RtHGJ"};